import React, { useContext } from 'react'
import { flowRight } from 'lodash'
import { useTranslation } from 'react-i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { getLocale } from 'lib/utils/getLocale'

import { GenericModalContext } from 'components/Modal/GenericModal/GenericModal'
import Link from 'components/Link'
import Button from 'components/UI/Button'
import Icon from 'components/Icon'
import IconBuyer from 'images/svg/icon/icon_buyer.svg'
import IconFinancing from 'images/svg/icon/icon_financing.svg'
import IconSeller from 'images/svg/icon/icon_seller.svg'
import IconCheckGreen from 'images/svg/icon/icon-icon-check-circle-green.svg'

import './financing-info.pcss'

const FinancingInfo = () => {
    const modalContext = useContext(GenericModalContext)

    const { t, i18n } = useTranslation('financing')

    return (
        <div className="financing-info">
            <div className="financing-info__title">
                <p>
                    {t('financing:infoModal.message')}
                </p>
            </div>
            <div className="financing-info__section">
                <div className="financing-info__section-row">
                    <div className="financing-info__section-title">
                        <div className="financing-info__section-icon">
                            <IconBuyer />
                        </div>
                        {t('financing:infoModal.description.data1.title')}
                    </div>
                    <div className="financing-info__section-content">
                        <div className="financing-info__section-icon">
                            <IconFinancing />
                        </div>
                        <span>
                            <p> - {t('financing:infoModal.description.data1.paragraph1')}</p>
                            <p> - {t('financing:infoModal.description.data1.paragraph2')}</p>
                        </span>
                    </div>
                </div>
                <div className="financing-info__section-row">
                    <div className="financing-info__section-title">
                        <div className="financing-info__section-icon">
                            <IconBuyer />
                        </div>
                        {t('financing:infoModal.description.data2.title')}
                    </div>
                    <div className="financing-info__section-content">
                        <div className="financing-info__section-icon">
                            <IconSeller />
                        </div>
                        <span>
                            <p> - {t('financing:infoModal.description.data2.paragraph1')}</p>
                        </span>
                    </div>
                </div>
                <div className="financing-info__section-row">
                    <div className="financing-info__section-title">
                        <div className="financing-info__section-icon" />
                        {t('financing:infoModal.description.data3.title')}
                    </div>
                    <div className="financing-info__section-content">
                        <div className="financing-info__section-icon" />
                        <span>
                            <p> - {t('financing:infoModal.description.data3.paragraph1')}</p>
                            <p> - {t('financing:infoModal.description.data3.paragraph2')}</p>
                            <p> - {t('financing:infoModal.description.data3.paragraph3')}</p>
                        </span>
                    </div>
                </div>
                <div className="financing-info__section-row financing-info__section-success">
                    <div className="financing-info__section-title">
                        <div className="financing-info__section-icon">
                            <IconCheckGreen />
                        </div>
                        {t('financing:infoModal.description.data4.title')}
                    </div>
                    <div className="financing-info__section-content">
                        <div className="financing-info__section-icon" />
                        <span>
                            <p> - {t('financing:infoModal.description.data4.paragraph1')}</p>
                            <p> - {t('financing:infoModal.description.data4.paragraph2')}</p>
                        </span>
                    </div>
                </div>
            </div>
            <div className="action-wrapper">
                <Link
                    to={`${getLocale(i18n.language)}/fiksut-kaupat`}
                    trackName="financingInfo"
                    className="button--tertiary"
                >
                    <span>{t('financing:infoModal.link')}</span>
                    <Icon name="icon_chevron_right" />
                </Link>
                <Button
                    onClick={modalContext.closeModal}
                    trackName="close"
                    className="button button--secondary"
                >
                    {t('common:close')}
                </Button>
            </div>
        </div>
    )
}
export default flowRight(
    withErrorBoundaryNoRender,
)(FinancingInfo)
